import type { OutfitterTypeForContext } from "~contexts/outfitter-provider"
import type {
    MinimalOutfitterFieldsFragment,
    OutfitterFieldsFragment,
} from "~graphql/outfitters.generated"
import {
    OutfitterStatus,
    SelfOnboardingStepType,
} from "~graphql/generated/types"

// The first three outfitter steps (info, addresses, description) must be
// completed before the onboarding flow can be exited
const REQUIRED_SELF_ONBOARDING_STEP_TYPES: SelfOnboardingStepType[] = [
    SelfOnboardingStepType.OutfitterV2,
    SelfOnboardingStepType.OutfitterInfoV2,
    SelfOnboardingStepType.OutfitterAddressesV2,
    SelfOnboardingStepType.OutfitterAboutV2,
]

export function isOutfitterSuspended(
    outfitter: { status: OutfitterStatus } | undefined
) {
    return outfitter?.status === OutfitterStatus.Suspended
}

export function getIsQuickBooksEnabled(
    outfitter?: OutfitterFieldsFragment | OutfitterTypeForContext | null
) {
    return outfitter?.enabled_integrations.is_quick_books_enabled ?? false
}

export function isOutfitterSelfOnboardingFinished(
    outfitter?: OutfitterFieldsFragment | MinimalOutfitterFieldsFragment | null
) {
    const currentStep = getCurrentOnboardingStep(outfitter)

    return currentStep === SelfOnboardingStepType.FinishedV2
}

export function getCurrentOnboardingStep(
    outfitter?: OutfitterFieldsFragment | MinimalOutfitterFieldsFragment | null
) {
    return (
        outfitter?.current_self_onboard_step ??
        SelfOnboardingStepType.FinishedV2
    )
}

export function hasPassedRequiredSelfOnboardingSteps(
    outfitter?: OutfitterFieldsFragment | MinimalOutfitterFieldsFragment | null
) {
    const currentStep = getCurrentOnboardingStep(outfitter)

    return !REQUIRED_SELF_ONBOARDING_STEP_TYPES.includes(currentStep)
}
